export const CollisionGroup = {
    none: 0,
    wall: 1,
    object: 2
};

export const CollisionCategory = {
    none: 0,
    static: 1,
    dynamic: 2
};
